<template>
  <div class="account_summary" id="account_summary">
    <AccountSummaryDesktop v-if="windowWidth > 992" />
    <AccountSummaryMobile v-else />
  </div>
</template>

<script>
import AccountSummaryDesktop from "./AccountSummaryDesktop";
import AccountSummaryMobile from "./AccountSummaryMobile";

export default {
  name: "Account",
  components: {
    AccountSummaryDesktop,
    AccountSummaryMobile,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    let that = this;
    window.addEventListener(
      "resize",
      function () {
        that.windowWidth = window.innerWidth;
      },
      false
    );
  },
};
</script>

<style lang="scss" scoped>
</style>
